import type { Auth } from '@/modules/common/adapters/auth.type.ts';
import type { AuthDto } from '@/modules/common/dto/auth.dto.ts';

export class AuthAdapter {
  static map(response: AuthDto): Auth {
    return {
      accessToken: response.token,
      refreshToken: response.refresh_token,
      dbType: response.db_type,
      storageUrl: response.storage_url,
    };
  }
}
